export const POLISH_ROADSIGN_RED_COLOR = '#c70036';
export const POLISH_ROADSIGN_WHITE_COLOR = '#ffffff';
export const POLISH_ROADSIGN_BLACK_COLOR = '#101828';
export const POLISH_ROADSIGN_GRAY_COLOR = '#505869';
